module.exports = __webpack_public_path__ + "static/4-72847ccb4abf08c48809ca0f59be9aac.svg";